export enum Identity {
  NRIC = 1,
  Passport = 2,
  
  // US Identity
  UsTin = 8,
  UsSSN = 9,
  UsIdNo = 10,
}
